const applicationStatus= {
    'submitted': 2,
    'approved': 3,
    'rejected': 2,
    'report_generated': 4
}

export {
    applicationStatus
}